import React from "react";
import ReactPaginate from "react-paginate";
import { joinClassnames } from "utils/map-modifier";
import "./index.scss";

interface PaginationProps {
  initialPage?: number;
  totalCount: number;
  limit: number;
  className?: string;
  spacingTop?: boolean;
  handlePageClick?: (selectedItem: { selected: number }) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  initialPage,
  limit,
  totalCount,
  className,
  spacingTop,
  handlePageClick,
}) => {
  const pageCount = Math.ceil(totalCount / limit);
  return (
    <div
      className={joinClassnames(
        "pagination-wrapper",
        className,
        spacingTop && "has-spacing-top",
      )}
    >
      <ReactPaginate
        {...(initialPage ? { initialPage } : {})}
        previousLabel="Trước"
        nextLabel="Sau"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        pageCount={pageCount}
        marginPagesDisplayed={1}
        pageRangeDisplayed={4}
        previousClassName="page-item"
        nextClassName="page-item"
        previousLinkClassName="page-link page-nav"
        nextLinkClassName="page-link page-nav"
        onPageChange={handlePageClick}
        containerClassName="pagination"
        activeClassName="active"
      />
    </div>
  );
};

Pagination.defaultProps = {};

export default Pagination;
